import { DEFAULT_LANG, DEFAULT_CURRENCY, STYLE_TYPE } from './constants';
import { isCurrencyCodeValid } from './validateCurrency';
function getFormatter(locale, currency, options) {
    let formatter;
    const currencyToUse = isCurrencyCodeValid(currency) ? currency : DEFAULT_CURRENCY;
    const formatterOptions = {
        style: STYLE_TYPE,
        currency: currencyToUse,
        ...(options || {}),
    };
    try {
        formatter = Intl.NumberFormat(locale, formatterOptions);
    }
    catch (err) {
        formatter = Intl.NumberFormat(DEFAULT_LANG, formatterOptions);
    }
    return formatter;
}
export function formatPrice({ locale = DEFAULT_LANG, currencyName = DEFAULT_CURRENCY, price, }) {
    const formatter = getFormatter(locale, currencyName);
    return price !== undefined ? formatter.format(Number(price)) : '';
}
/**
 * TODO: (D.K.) Need investigate this function (similar 'formatPrice')
 * @deprecated getFormattedPrice (use formatPrice)
 */
export function getFormattedPrice({ language = DEFAULT_LANG, attr, }) {
    if (!attr || !attr?.amount) {
        return undefined;
    }
    const formattedPrice = formatPrice({
        locale: language,
        currencyName: attr?.currencyCode,
        price: attr?.amount,
    });
    return formattedPrice;
}
export function getPricesValues({ prices, language, }) {
    if (!prices || !prices.length || !prices[0]?.currencyCode) {
        return {
            priceValue: undefined,
            discountedPrice: undefined,
        };
    }
    const { currencyCode } = prices[0];
    const priceValue = formatPrice({
        locale: language,
        currencyName: currencyCode,
        price: prices[0].amount,
    });
    const discountedPrice = prices[0].discount?.discountedPrice;
    const discountedValue = discountedPrice &&
        formatPrice({
            locale: language,
            currencyName: currencyCode,
            price: discountedPrice,
        });
    return {
        priceValue,
        discountedValue,
    };
}
